/*
========================================================
ESTIMATED SHIPPING - HOMETOMATO SWEDEN
========================================================

Reference address:
Strömgatan 15
111 52 Stockholm
Sverige

Logic:
- Most restrictive / highest shipping method wins
- Product tags override standard parcel rates
- Heavy carts over 20 kg are treated as pallet shipping
- Vasalund has its own price rules, unless pallet_only is also present

========================================================
*/

let estimatedShippingTimeout;

async function getProductTags(handle) {
  try {
    const response = await fetch(`/products/${handle}.js`);
    const product = await response.json();
    return product.tags || [];
  } catch (error) {
    console.log('Kunde inte hämta tags:', handle, error);
    return [];
  }
}

function normalizeTag(tag) {
  return String(tag || '').trim().toLowerCase();
}

function hasTag(cartTags, tag) {
  return cartTags.includes(normalizeTag(tag));
}

function formatPrice(price) {
  if (price === 0) return '0 kr';
  return `${price},00 kr`;
}

async function loadEstimatedShipping() {
  const wrapper = document.querySelector('[data-estimated-shipping]');
  if (!wrapper) return;

  clearTimeout(estimatedShippingTimeout);

  estimatedShippingTimeout = setTimeout(async () => {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      if (!cart.items || !cart.items.length) {
        wrapper.innerHTML = 'Frakt beräknas i kassan';
        return;
      }

      const totalWeight = cart.total_weight;
      const totalPrice = cart.total_price / 100;

      const handles = [...new Set(cart.items.map(item => item.handle))];
      const tagArrays = await Promise.all(handles.map(getProductTags));
      const cartTags = [...new Set(tagArrays.flat().map(normalizeTag))];

      let shippingPrice = null;

      /*
      ========================================================
      PRIORITY ORDER
      ========================================================
      1. No shipping
      2. Special acoustic panels
      3. Pallet / heavy shipping
      4. Vasalund
      5. Parcel home
      6. GLS
      7. Standard pickup point
      ========================================================
      */

      if (hasTag(cartTags, 'no_shipping')) {
        shippingPrice = null;

      } else if (hasTag(cartTags, 'special levering - akustikpanel')) {
        if (totalWeight >= 306000) {
          shippingPrice = 0;
        } else if (totalWeight >= 204000) {
          shippingPrice = 599;
        } else if (totalWeight >= 122000) {
          shippingPrice = 799;
        } else if (totalWeight >= 60000) {
          shippingPrice = 999;
        } else {
          shippingPrice = 5000;
        }

      } else if (hasTag(cartTags, 'pallet_only') || totalWeight > 20000) {
        shippingPrice = totalWeight <= 50000 ? 398 : 399;

      } else if (hasTag(cartTags, 'vasalund')) {
        if (totalWeight < 35000) {
          shippingPrice = 197;
        } else if (totalWeight < 65000) {
          shippingPrice = 297;
        } else {
          shippingPrice = 397;
        }

      } else if (hasTag(cartTags, 'parcel_home')) {
        shippingPrice = 299;

      } else if (hasTag(cartTags, 'kungls') || hasTag(cartTags, 'kunGLS')) {
        shippingPrice = 119;

      } else {
        if (totalWeight <= 4990) {
          shippingPrice = 99;
        } else if (totalWeight <= 9990) {
          shippingPrice = 119;
        } else if (totalWeight <= 14990) {
          shippingPrice = 129;
        } else if (totalWeight <= 20000) {
          shippingPrice = 159;
        } else if (totalWeight <= 50000) {
          shippingPrice = 398;
        } else {
          shippingPrice = 399;
        }
      }

      if (shippingPrice === null) {
        wrapper.innerHTML = 'Frakt beräknas i kassan';
        return;
      }

      wrapper.innerHTML = `
        Beräknad frakt från <strong>${formatPrice(shippingPrice)}</strong><br>
        <small>Fraktpriset är vägledande. Slutgiltig fraktkostnad beräknas när adressuppgifterna har angetts i kassan.</small>
      `;

      console.log('Cart weight:', totalWeight);
      console.log('Cart price:', totalPrice);
      console.log('Cart tags:', cartTags);
      console.log('Estimated shipping:', shippingPrice);

    } catch (error) {
      console.log('Estimated shipping error:', error);
      wrapper.innerHTML = 'Frakt beräknas i kassan';
    }
  }, 300);
}

loadEstimatedShipping();

document.addEventListener('cart:updated', loadEstimatedShipping);
document.addEventListener('cart:refresh', loadEstimatedShipping);
document.addEventListener('cart-drawer:open', loadEstimatedShipping);

const observer = new MutationObserver(() => {
  if (document.querySelector('[data-estimated-shipping]')) {
    loadEstimatedShipping();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});